/**
 * @param {string|number} price
 * @param {boolean} showFloat
 * @returns {string|number}
 */
export function formatPrice(price, showFloat = undefined) {
  const decimal = 2
  price = price.toString()

  const pricePow = Math.pow(10, decimal)
  const roundedPrice = Math.round(price * pricePow) / pricePow

  if (
    typeof showFloat === 'undefined' &&
    typeof window.default_price_float !== 'undefined'
  ) {
    showFloat = window.default_price_float
  }

  if (showFloat) {
    const v = roundedPrice.toString().split('.')

    if (decimal <= 0) return v[0]
    let f = v[1] || ''
    while (f.length < decimal) f += '0'

    return `${v[0]}.${f}`
  }

  return roundedPrice
}

/**
 *
 * @param price
 * @returns {number}
 */
export function roundPrice(price) {
  price = price.toString()

  const pricePow = Math.pow(10, 2)
  return Math.round(price * pricePow) / pricePow
}

/**
 * @param {number|string} price
 * @param {number|string} [vat=0]
 * @return {number}
 */
export function vatPrice(price, vat = 0) {
  price = parseFloat(price)
  vat = parseFloat(vat)

  return price + (price * vat) / 100
}

/**
 * @param {number|string} price
 * @param {number|string} [vat=0]
 * @return {number}
 */
export function removeVatPrice(price, vat = 0) {
  price = parseFloat(price)
  vat = parseFloat(vat)

  return price / ((100 + vat) / 100)
}
